export default __webpack_public_path__ + "static/media/hour-glass-icon.7bc923bc.svg";